var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('dinapsis-navbar',{domProps:{"menu":_vm.menu,"heightToolbar":77,"keycloak":_vm.KeycloakInstance()},on:{"click-menu":function($event){return _vm.menuClicked($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }